import { Component, OnInit } from '@angular/core';
import { OnboardingV2Service } from "@mpt-fo/common/core/services/onboarding-v2.service";
import { ModalService } from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import { NibssVerificationService } from "@mpt-fo/common/core/services/nibss-verification.service";
import {
	KYC_IDENTITY_TYPE,
	KYCFormKeys
} from "@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model";
import {
	BoKycLvl1SelectIdentityTypeComponent
} from "@app/channels/onboarding/onboarding-v2/kyc-v2/partials/bo-kyc/partials/bo-kyc-lvl1/partials/bo-kyc-lvl1-select-idetity-type/bo-kyc-lvl1-select-identity-type.component";
import { ScreenManagerService } from "@mpt-fo/common/core/services/screen-manager.service";
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';

@Component({
	selector: 'app-bo-kyc-lvl2-identity-type-selected-v2',
	templateUrl: './bo-kyc-lvl2-identity-type-selected-v2.component.html',
	styleUrls: ['./bo-kyc-lvl2-identity-type-selected-v2.component.scss']
})
export class BoKycLvl2IdentityTypeSelectedV2Component extends BoKycLvl1SelectIdentityTypeComponent implements OnInit {
	kycLvl2Steps;
	isMobile: boolean;
	constructor(
		public onboardingService: OnboardingV2Service,
		public modalService: ModalService,
		nibssService: NibssVerificationService,
		private screenManagerService: ScreenManagerService,
		public dataLayerHelper: DataLayerService,
		public localStorage: LocalStorageService,
	) {
		super(onboardingService, modalService, nibssService, dataLayerHelper, localStorage);
	}

	async initialize() {
		this.showDismissModal();
		this.allowNibssBvnVerification = this.onboardingService.useNibssBvnVerification();
		this.updateForm();
		this.setFormTitle();
		this.setCurrentView();
		this.setFormParameters();
	}

	getModalParams() {
		return {
			callbackName: 'Continue',
			title: 'Update your NIN Information',
			cancelName: 'Go Dashboard',
			description: 'Please submit your NIN information to continue enjoying level benefits',
			alertType: 'info'
		}
	}

	showDismissModal() {
		const obj = this.getModalParams();
		this.onboardingService.launchModal(obj)
			.then(res => {
				if (!res?.resolved) { this.onboardingService.routeToBODashboard() }
				else {
					this.onboardingService.closeModal();
				}
			});
	}
	setFormTitle() {
		this.onboardingService.isNinIdentitySource() ? this.setBvnParameter() : this.setNinParameter();
	}

	updateForm() {
		if (this.onboardingService.getBankVerificationNumberFromKyc()) {
			this.setBvnIfAlreadySubmitted(this.formData);
		}
	}

	setFormParameters() {
		const formParameters = this.onboardingService.getBoKycLvl2FormParameters(this.getCurrentFormKey());
		this.totalStep = formParameters?.totalStep;
		this.kycLvl2Steps = formParameters?.kycLvl2Steps;
		this.currentFormStep = formParameters?.currentFormStep;
		this.formSteps = formParameters?.formSteps;
	}

	setCurrentView() {
		this.currentView = this.onboardingService.isNinIdentitySource() ? KYC_IDENTITY_TYPE.BVN : KYC_IDENTITY_TYPE.NIN;
	}

	getCurrentFormKey() {
		return this.onboardingService.isNinIdentitySource() ? KYCFormKeys.BVN_COMPLETED : KYCFormKeys.NIN_COMPLETED;
	}

	routeToNextStep() {
		this.goBack();
	}

	setBvnIfAlreadySubmitted(formData: { bvn: string; dateOfBirth: string }) {
		formData.bvn = this.onboardingService.getBankVerificationNumberFromKyc();
	}

	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
	}

	goBack() {
		this.onboardingService.routeToBODashboard();
	}

}
